<template>
  <blog-form />
</template>

<script>
import BlogForm from '@/components/forms/BlogForm'
export default {
  components: {
    BlogForm
  }
}
</script>
